import { DownloadCSVProps } from "./types";
import { formatRevenueRange } from "../../../CompanyList/utils";

/**
 * Formats a date string to the format "MMM DD, YYYY" (e.g., "Jan 01, 2023")
 * @param dateString - The date string to format
 * @returns The formatted date string
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "";

  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return dateString;

  // Format date as "MMM DD, YYYY"
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const exportCompetitorKeyDetectionCSV = ({
  headers,
  data,
}: DownloadCSVProps): void => {
  if (!data || data.length === 0) return;
  const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
  const fileName = `competitor-key-detection-${timestamp}.csv`;
  const headerRow = headers.map((header) => header.title).join(",");

  const dataRows = data
    .map((row) =>
      headers
        .filter((header) => !header.hideOnExport)
        .map((header) => {
          if (header.field === "revenueMax") {
            const revenueRange = formatRevenueRange({
              min: row.revenueMin as number | null,
              max: row.revenueMax as number | null,
            });
            if (revenueRange.includes(",")) {
              return `"${revenueRange}"`;
            }
            return revenueRange;
          }

          const value = row[header.field];

          if (typeof value === "string" && value.includes(",")) {
            return `"${value}"`;
          }
          return value !== undefined ? value : "";
        })
        .join(",")
    )
    .join("\n");

  const csvContent = `${headerRow}\n${dataRows}`;

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", fileName);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
